import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ content: null, reload: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const reload = () => api.get("/site/content").then((r) => setContent(r.data)).catch(() => setContent({ clients: [] }));
  useEffect(() => { reload(); }, []);
  return <Ctx.Provider value={{ content, reload }}>{children}</Ctx.Provider>;
}

export const useSiteContent = () => useContext(Ctx);
export const fileUrl = (u) => `${process.env.REACT_APP_BACKEND_URL}${u}`;
